import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonationBanner"] */ "/vercel/path0/apps/web/src/components/layout/impersonation-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeDebugOverlay"] */ "/vercel/path0/apps/web/src/components/native/native-debug-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeOfflineBanner"] */ "/vercel/path0/apps/web/src/components/native/native-offline-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeProvider"] */ "/vercel/path0/apps/web/src/components/native/native-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsScripts"] */ "/vercel/path0/apps/web/src/components/providers/analytics-scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/vercel/path0/apps/web/src/components/providers/app-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionAnalyticsBoundary"] */ "/vercel/path0/apps/web/src/components/providers/session-analytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.24_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.58.2_@types_44f2ee469e58ebe5dd8142f76b11dd6e/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
